import styled from '@emotion/styled';
import { Typography, Button } from '@mgmresorts/mgm-ui';

import { NavigationLink } from '../../components/ui/Link';
import { convertFontWeight } from '../../utils/vegaTokenHelpers';

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.HeadingMedium2.fontSize}px;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
export const StyledNavigationLink = styled(NavigationLink)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;
export const StyledLegalText = styled(Typography)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  color: ${({ theme }) => theme.semantic.FgContrast};
  font-size: ${({ theme }) => theme.core.FontsizeXs}px;
  font-weight: ${({ theme }) => convertFontWeight(theme.core.Fontweight400)};
`;
